module.exports = __webpack_public_path__ + "media/decScore.ea7f79e6.wav";